import { Col, Row } from 'antd'
import { useLocation } from 'react-router-dom';
import iconBtnAccept from '../../../images/candidateCard/btn-accept.png'
import iconBtnDecline from '../../../images/candidateCard/btn-decline.png'
import iconBtnAcceptFr from '../../../images/candidateCard/btn-accept-fr.png'
import iconBtnDeclineFr from '../../../images/candidateCard/btn-decline-fr.png'
import { useEffect } from 'react';

// Component
const ButtonsSection = () => {
    // React Hooks
    const location = useLocation();

    useEffect(() => {

        // Esto divide la cadena en un array por cada '/'

        console.log(location.pathname.split('/')[1])
    }, [location.pathname])

    return (
        <Row style={{ width: "60%", paddingBottom: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Col xs={24} sm={12} md={12} lg={12} xxl={12}
                style={{ height: '100%', display: "flex", justifyContent: "center", alignItems: "center" }}
            >

                <img
                    src={location.pathname.split('/')[1] === 'en' ? iconBtnAccept : iconBtnAcceptFr}
                    style={{ height: 80, width: 180, marginTop: -10 }}
                    alt={iconBtnAccept}
                />
            </Col>

            <Col xs={24} sm={12} md={12} lg={12} xxl={12} style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>

                <img
                    src={location.pathname.split('/')[1] === 'en' ? iconBtnDecline : iconBtnDeclineFr}
                    style={{ height: 80, width: 180, marginTop: -10 }}
                    alt={iconBtnAccept}
                />
            </Col>
        </Row>
    )
}

export default ButtonsSection
